<app-main-layout [mainTemplateRef]="main" [requireLogin]="false">
  <ng-template #main>
    <main>
      <article>
        <header><mat-icon>warning</mat-icon></header>
        <section>
          <h1 class="mat-h1">{{ 'uix.404.title' | translate }}</h1>
          <p>{{ 'uix.404.message' | translate }}</p>
        </section>
      </article>
    </main>
  </ng-template>
</app-main-layout>
